import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { UtilityService } from '../../service/utility.service';
import { NotificationService } from '../../service/notification.service';
import { LoadingService } from '../../service/loading.service';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { Login } from '../../models/LoginView';
import { AuthenticationService } from '../../service/authentication.service';

@Component({
  selector: 'app-vendor-forgot-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './vendor-forgot-password.component.html',
  styleUrl: './vendor-forgot-password.component.css',
})
export class VendorForgotPasswordComponent implements OnInit {
  submitted: boolean = false;
  idForm: FormGroup;
  form: FormGroup;
  prefixLabel: string = '';

  constructor(
    private formBuilder: FormBuilder,
    public utilityService: UtilityService,
    private notificationService: NotificationService,
    private spinner: LoadingService,
    private authenticationServices: AuthenticationService,
  ) {
    this.idForm = this.formBuilder.group({
      email: [null, [Validators.email, Validators.required]],
    });
  }
  ngOnInit() {}

  onSubmit() {
    this.submitted = true;
    if (this.idForm.invalid) {
      this.utilityService.getFormValidationErrors(this.idForm);
      this.notificationService.showError('Invalid email.', 'Error');
      return;
    }

    let request = _.cloneDeep(this.idForm.value);
    let requestCall;
    this.spinner.OnLoading.emit(true);
    requestCall = this.authenticationServices.forgotPassword(request.email);
    requestCall.subscribe(
      (_) => {
        this.spinner.OnLoading.emit(false);
        this.notificationService.showSuccess(
          'If an account with that email exists, you’ll receive a password reset link shortly.',
          'Success',
        );
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'There is an error while processing your request. Please try again later.',
          confirmButtonText: 'OK',
        });
        this.notificationService.showError(err, 'Error');
      },
    );
  }

  get f() {
    return this.idForm.controls;
  }

  get idf() {
    return this.idForm.controls;
  }
}
